@if(loadingStripe()){
  <app-loading></app-loading>
}@else {
  <div class="container">
    @if(!loading()){
      <div class="action">
        <span>{{ 'profile.account' | translate }}</span>
      </div>
      <div class="action-container">
        <div class="profile-container">
          <div class="info">
            <div class="row">
              <span class="label">{{ 'profile.name' | translate }}</span>
              <span class="content">{{authService.user()?.first_name +' '+authService.user()?.last_name}}</span>
            </div>
            <div class="row email-row">
              <span class="label">{{ 'profile.email' | translate }}</span>
              <span class="content">{{authService.user()?.email}}</span>
            </div>   
            <div class="row">
              <span class="label">{{ 'profile.profile' | translate }}</span>
              <span class="content">{{ getUserProfile().label | translate }}</span>
            </div>
            <div class="row">
              <span class="label">{{ 'profile.language' | translate }}</span>
              <span class="content">{{getLanguage().name}}</span>
            </div>
          </div>
          <div class="change">
            <mat-icon matRipple (click)="view('account')">edit</mat-icon>
          </div>            
        </div>
      </div>

      @if(psychologist() && authService.user()?.profile === PROFILES.PSYCHOLOGIST.key){
        <div class="action">
          <span>{{ 'profile.psychologist_profile' | translate }}</span>
        </div>
        <div class="action-container">
          <div class="profile-container">
            <div class="info">
              <div class="row">
                <span class="label">{{ 'profile.license' | translate }}</span>
                <span class="content">{{psychologist()?.council_number}}</span>
              </div>
              <div class="row">
                <span class="label">{{ 'profile.country' | translate }}</span>
                <span class="content">{{getCountryName(psychologist()?.council_country || '')}}</span>
              </div>
              <div class="row">
                <span class="label">{{ 'profile.languages' | translate }}</span>
                <span class="content">{{getSessionLanguage()}}</span>
              </div>   
            </div>
            <div class="change">
              <mat-icon matRipple (click)="view('psychologist-profile')">edit</mat-icon>
            </div>            
          </div>
        </div>
      }
    
      @if(psychologist() && authService.user()?.profile === PROFILES.PSYCHOLOGIST.key){
        <div class="action">
          <span>{{ 'profile.subscription' | translate }}</span>
        </div>
        <div class="action-container">
          @if (psychologist()?.subscription_plan && psychologist()?.subscription_plan !== PLANS.STARTER.code){        
            <div class="subscription-container">
              <div class="info">
                <div class="row">
                  <span class="label">{{ 'profile.plan' | translate }}</span>
                  <span class="content">{{PLANS[psychologist()?.subscription_plan || ''].label | translate}}</span>
                </div>   
                <div class="row">
                  <span class="label">{{ 'profile.status' | translate }}</span>
                  <span class="content">{{STRIPE_STATUS[psychologist()?.subscriptions?.status || ''].label | translate}}</span>
                </div>
                <div class="row">
                  <span class="label">{{ 'profile.next_payment' | translate }}</span>
                  <span class="content">{{$safeNavigationMigration(psychologist()?.subscriptions?.current_period_end) | date:'dd/MM/yyyy'}}</span>
                </div>
              </div>
              <div class="change">
                <mat-icon matRipple (click)="view('stripe-sub-area')">settings</mat-icon>
              </div>            
            </div>  
          }@else {
            <div matRipple class="action-item logout" (click)="view('choose-a-plan')">
              <mat-icon>workspace_premium</mat-icon>
              <span>{{'profile.choose_plan' | translate}}</span>
            </div>
            <div matRipple class="action-item logout" (click)="restoreSubscription()">
              <mat-icon>sync</mat-icon>
              <div>
                <span>{{'profile.restore_subscription' | translate}}</span>
                <span class="support" >{{ 'profile.restore_sub_support' | translate }}</span>
              </div>
            </div>
          }
        </div>
      }
    
      @if(!psychologist()){
        <div class="action">
          <span>{{'profile.associated' | translate}}</span>
        </div>
        <div class="action-container">
          @if(!userPsychologist()) {
            <div matRipple class="action-item logout" (click)="view('request-association')">
              <mat-icon>people_outline</mat-icon>
              <span>{{'profile.request_association' | translate}}</span>
            </div>
          } @else {
            <div class="association-container">
              <div class="info">
                <div class="row">
                  <span class="label">{{ 'profile.name' | translate }}</span>
                  <span class="content">{{userPsychologist()?.psychologists?.first_name + ' ' + userPsychologist()?.psychologists?.last_name}}</span>
                </div>   
                <div class="row">
                  <span class="label">{{ 'profile.license' | translate }}</span>
                  <span class="content">{{userPsychologist()?.psychologists?.council_number}}</span>
                </div>
                <div class="row">
                  <span class="label">{{ 'profile.country' | translate }}</span>
                  <span class="content">{{userPsychologist()?.psychologists?.council_country}}</span>
                </div>
                <div class="row">
                  <span class="label">{{ 'profile.status' | translate }}</span>
                  <span class="content">{{STATUS[userPsychologist()?.status || ''].label | translate}}</span>
                </div>
                @if (userPsychologist()?.psychologists?.phone_number) {
                  <div class="row">
                    <span class="label">{{ "profile.contact" | translate }}</span>
                    <a [href]="'https://wa.me/' + $safeNavigationMigration(userPsychologist()?.psychologists?.phone_number)"><img class="wapp-icon" src="/imgs/wapp_logo.png" alt="icon from whatsapp"></a>
                  </div>
                }
              </div>
              <div class="change">              
                <mat-icon matRipple (click)="view('request-association')">autorenew</mat-icon>
                <mat-icon class="remove" matRipple (click)="removeAssociation()">group_off</mat-icon>
              </div>            
            </div>
          }        
        </div>
      }
    
      @if(psychologist()){
        <div class="action">
          <span>{{'profile.patient_list' | translate}}</span>
        </div>
        <div class="action-container">          
          <div matRipple class="action-item logout" (click)="view('patient-list')">
            <mat-icon>perm_contact_calendar</mat-icon>
            <span>{{'profile.view_patient_list' | translate}}</span>
          </div>
          <div matRipple class="action-item logout" (click)="view('invite-patient')">
            <mat-icon>group_add</mat-icon>
            <span>{{'profile.invite_patient' | translate}}</span>
          </div>          
          <div matRipple class="action-item logout" (click)="view('invite-list')">
            <mat-icon>list_alt</mat-icon>
            <span>{{'profile.pending_invites' | translate}}</span>
          </div>          
        </div> 
      }

      @if(psychologist()){
        <div class="action">
          <span>{{'profile.financial' | translate}}</span>
        </div>
        <div class="action-container">
          <div matRipple class="action-item logout" (click)="view('appointments-report')">
            <mat-icon>receipt_long</mat-icon>
            <span>{{'profile.appointments_report' | translate}}</span>
          </div>
        </div>
      }
    
        <div class="action">
          <span>{{'profile.actions' | translate}}</span>
        </div>
        <div class="action-container">  
      
        @if(!psychologist() && authService.user()?.profile !== PROFILES.ADMIN.key){
          <div matRipple class="action-item logout" (click)="view('become-psychologist')">
            <mat-icon>badge</mat-icon>
            <span>{{'profile.psychologist' | translate}}</span>
          </div>
        }
        <div matRipple class="action-item logout" (click)="view('terms')">
          <mat-icon>chrome_reader_mode</mat-icon>
          <span>{{'profile.terms' | translate}}</span>
        </div>
        <div matRipple class="action-item logout" (click)="view('policies')">
          <mat-icon>chrome_reader_mode</mat-icon>
          <span>{{'profile.policies' | translate}}</span>
        </div>   
        <div matRipple class="action-item logout" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>{{'profile.logout' | translate}}</span>
        </div>
        <div matRipple class="action-item delete" (click)="deleteAccount()">
          <mat-icon>delete</mat-icon>
          <span>{{'profile.delete_account' | translate}}</span>
        </div>
      </div>
    }
    <div class="version">
      <span>{{getVersion()}}</span>
    </div>
  </div>  
}
